/* KYARNA Quick View — global controller
   Usage: add data-ky-quickview="{{ product.handle }}" to any button/element
   across Homepage / Collection / Search / Related Products cards.
   Works via event delegation so it functions even on dynamically rendered cards. */
(function () {
  'use strict';

  var overlay, modal, body, closeBtn, currentProduct, currentVariant;

  function init() {
    overlay = document.getElementById('ky-qv-overlay');
    modal = document.getElementById('ky-qv-modal');
    body = document.getElementById('ky-qv-body');
    closeBtn = document.getElementById('ky-qv-close');
    if (!overlay) return;

    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    // Event delegation: catches any current or future quick-view trigger,
    // supporting both attribute naming conventions used across card grids.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-ky-quickview], [data-kyarna-quick-view]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = trigger.getAttribute('data-ky-quickview') || trigger.getAttribute('data-product-handle');
      if (handle) open(handle);
    });
  }

  function open(handle) {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    body.innerHTML = '<div class="ky-qv-loading"><div class="ky-qv-spinner"></div></div>';

    fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('not found');
        return r.json();
      })
      .then(function (product) {
        currentProduct = product;
        currentVariant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
        render(product);
      })
      .catch(function () {
        body.innerHTML = '<div class="ky-qv-error">Unable to load this product. <a href="/products/' + handle + '" style="color:#c4a060;">View full page</a></div>';
      });
  }

  function close() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function render(product) {
    var img = (currentVariant.featured_image && currentVariant.featured_image.src) || (product.images[0] || '');
    var hasOptions = product.options && product.options.length && product.options[0] !== 'Title';

    var optionsHtml = '';
    if (hasOptions) {
      product.options.forEach(function (optionName, idx) {
        var values = [];
        product.variants.forEach(function (v) {
          var val = v.options[idx];
          if (values.indexOf(val) === -1) values.push(val);
        });
        optionsHtml += '<div class="ky-qv-option-group">' +
          '<span class="ky-qv-option-label">' + optionName + '</span>' +
          '<div class="ky-qv-option-values">' +
          values.map(function (val) {
            var matchingVariant = product.variants.find(function (v) { return v.options[idx] === val; });
            var isSelected = currentVariant.options[idx] === val;
            var isAvailable = product.variants.some(function (v) { return v.options[idx] === val && v.available; });
            return '<button type="button" class="ky-qv-swatch' + (isSelected ? ' is-selected' : '') + '"' +
              (isAvailable ? '' : ' disabled') +
              ' data-option-index="' + idx + '" data-option-value="' + val.replace(/"/g, '&quot;') + '">' + val + '</button>';
          }).join('') +
          '</div></div>';
      });
    }

    var priceHtml = '<span class="ky-qv-price">' + formatMoney(currentVariant.price) + ' ' + (window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : '') + '</span>';
    if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
      priceHtml += '<span class="ky-qv-compare">' + formatMoney(currentVariant.compare_at_price) + '</span>';
    }

    body.innerHTML =
      '<div class="ky-qv-content">' +
        '<div class="ky-qv-media"><img src="' + img + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="eager"></div>' +
        '<div class="ky-qv-info">' +
          (product.vendor ? '<span class="ky-qv-vendor">' + product.vendor + '</span>' : '') +
          '<h2 class="ky-qv-title">' + product.title + '</h2>' +
          '<div class="ky-qv-price-row">' + priceHtml + '</div>' +
          '<div class="ky-qv-options">' + optionsHtml + '</div>' +
          '<div class="ky-qv-atc">' +
            '<button type="button" class="ky-qv-atc-btn" id="ky-qv-atc-btn"' + (currentVariant.available ? '' : ' disabled') + '>' +
              (currentVariant.available ? '+ Add to Cart' : 'Sold Out') +
            '</button>' +
            '<a href="' + product.url + '" class="ky-qv-viewfull">View Full Details</a>' +
          '</div>' +
        '</div>' +
      '</div>';

    body.querySelectorAll('.ky-qv-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var val = btn.getAttribute('data-option-value');
        var newOptions = currentVariant.options.slice();
        newOptions[idx] = val;
        var match = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === newOptions[i]; });
        });
        if (match) {
          currentVariant = match;
          render(product);
        }
      });
    });

    var atcBtn = document.getElementById('ky-qv-atc-btn');
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (!currentVariant.available) return;
        atcBtn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: currentVariant.id, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            atcBtn.textContent = '\u2713 Added to Cart';
            atcBtn.classList.add('is-added');
            return fetch('/cart.js', { headers: { Accept: 'application/json' } });
          })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
              el.removeAttribute('hidden');
              var s = el.querySelector('span[aria-hidden]');
              if (s) s.textContent = cart.item_count;
            });
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            ['kmb-cart-badge', 'kynav-cart-badge'].forEach(function (id) {
              var el = document.getElementById(id);
              if (!el) return;
              el.textContent = cart.item_count;
              cart.item_count > 0 ? el.classList.add('on') : el.classList.remove('on');
            });
            fetch('/?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (s) {
                if (!s['cart-icon-bubble']) return;
                var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
                var nb = doc.querySelector('.cart-count-bubble');
                var ob = document.querySelector('.cart-count-bubble');
                if (nb && ob) { ob.innerHTML = nb.innerHTML; ob.removeAttribute('hidden'); }
              })
              .catch(function () {});
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: 'kyarna-quick-view', data: { itemCount: cart.item_count, source: 'kyarna-quick-view' } },
            }));
            setTimeout(close, 900);
          })
          .catch(function () {
            atcBtn.textContent = 'Error — try again';
          });
      });
    }
  }

  window.kyQuickView = open;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
